/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    parts: [
        'footer',
        'footerHeading',
        'footerContent',
        'footerSubscribeSection',
        'footerEmail',
        'footerSocialIcons',
        'footerLocaleSelector',
        'footerLinks',
        'newsLetterEmailContainer',
        'newsLetterEmailInput',
        'newsLetterSubmitBtn'
    ],
    baseStyle: {
        footer: {
            direction: 'column',
            padding: '20px',
            background: 'black',
            color: 'white',
            minWidth: 'xs',
            margin: '0 auto',
            maxWidth: [
                'container.base',
                'container.sm',
                'container.md',
                'container.lg',
                'container.xl',
                'container.2xl'
            ],
            width: '100%',
            paddingLeft: {base: '16px', lg: '32px', xl: '64px'},
            paddingRight: {base: '16px', lg: '32px', xl: '64px'},
            paddingTop: {base: '24px', sm: '32px'},
            paddingBottom: {base: '24px', sm: '32px'}
        },
        footerHeading: {
            cursor: 'pointer',
            fontSize: '30px',
            fontWeight: '900',
            letterSpacing: '5px',
            textTransform: 'uppercase',
            background: 'black',
            color: 'white',
            alignItems: 'center',
            justifyContent: 'center'
        },
        footerContent: {
            padding: '20px',
            background: 'black',
            color: 'white',
            fontSize: '0.75rem'
        },
        footerSubscribeSection: {
            direction: 'column'
        },
        footerEmail: {
            width: '100%',
            padding: {base: '0', md: '0 16px'}
        },
        footerSocialIcons: {
            width: '100%',
            marginTop: '20px',
            marginBottom: '25px'
        },
        footerLocaleSelector: {
            display: 'inline-block'
        },
        footerLinks: {
            justifyContent: 'space-between',
            flex: {base: '100%', md: '0 0 66.66666667%'},
            maxWidth: {base: '100%', md: '66.66666667%'}
        },
        newsLetterHeading: {
            fontSize: 'xl',
            mb: '3',
            fontWeight: 'extrabold',
            lineHeight: '5'
        },
        newsLetterEmailContainer: {
            bg: 'white',
            borderRadius: 'lg',
            overflow: 'hidden',
            alignItems: 'center'
        },
        newsLetterEmailInput: {
            border: 'none',
            outline: 'none',
            fontSize: 'xs',
            fontWeight: 'medium',
            color: '#23252B',
            lineHeight: '5',
            _placeholder: {
                color: '#6c757d'
            },
            flex: '1',
            px: '4'
        },
        newsLetterSubmitBtn: {
            bg: 'orangeBaseColor',
            color: '#141519',
            borderTopLeftRadius: '0',
            borderBottomLeftRadius: '0',
            borderTopRightRadius: '8px',
            borderBottomRightRadius: '8px',
            px: 4,
            fontSize: 'md',
            fontWeight: 'bold',
            height: '48px',
            textTransform: 'uppercase',
            lineHeight: 4,
            _hover: {
                bg: 'orangeBaseColor',
                color: 'textColor'
            }
        },
        footerMainBlock: {
            background: 'textColor'
        },
        footerContentBlock: {
            display: {base: 'grid', md: 'flex !important'},
            margin: '0 -12.5px'
        },
        countryFooter: {
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: '16px',
            paddingBottom: {base: '0', sm: '16px'},
            marginTop: {base: '0', sm: '16px'},
            display: {base: 'grid !important', sm: 'flex !important'}
        },
        countrySelector: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#dadada',
            fontSize: 'xs',
            fontWeight: 800,
            lineHeight: '4',
            cursor: 'pointer',
            paddingRight: '4',
            marginBottom: {base: '4', sm: '0'}
        },
        changeRegionBtn: {
            paddingRight: '16px',
            paddingLeft: '20px',
            height: 'auto',
            fontSize: '12px',
            color: 'inherit',
            borderRight: '1px solid white',
            borderRadius: 'unset',
            backgroundRepeat: 'no-repeat'
        },
        footerCopyright: {
            fontSize: '12px',
            fontWeight: '500',
            lineHeight: '20px',
            color: '#dadada'
        }
    }
}
